import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CtaBand = () => (
  <section className="py-24 md:py-40 border-t border-line" data-testid="cta-band">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12 flex flex-col md:flex-row md:items-end justify-between gap-10">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight max-w-3xl"
      >
        Let's design the gown <span className="italic">only you</span> could wear
      </motion.h2>
      <Link
        to="/contact"
        data-testid="cta-book-link"
        className="btn-fill group shrink-0 inline-flex items-center gap-3 border border-ink px-10 py-5 text-xs uppercase tracking-[0.25em] font-medium hover:text-ivory transition-colors duration-500"
      >
        Book an appointment
        <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
      </Link>
    </div>
  </section>
);
